// Emoji data with keyword mappings for search functionality
// Maps emojis to searchable keywords (emotions, descriptions)

export const EMOJI_KEYWORDS = {
  "😀": ["happy", "smile", "grin", "joy", "cheerful"],
  "😃": ["happy", "smile", "grin", "joy", "cheerful"],
  "😄": ["happy", "smile", "grin", "joy", "cheerful"],
  "😁": ["happy", "smile", "grin", "beam", "joy"],
  "😆": ["happy", "laugh", "lol", "joy", "funny"],
  "😅": ["happy", "sweat", "smile", "nervous", "relief"],
  "😂": ["happy", "laugh", "lol", "joy", "tears", "funny"],
  "🤣": ["happy", "laugh", "lol", "joy", "rolling", "funny"],
  "😊": ["happy", "smile", "blush", "warm", "friendly"],
  "😇": ["happy", "angel", "innocent", "blessed", "halo"],
  "🙂": ["happy", "smile", "content", "okay", "fine"],
  "🙃": ["happy", "upside", "silly", "funny", "ironic"],
  "😉": ["happy", "wink", "flirty", "playful", "cheeky"],
  "😌": ["happy", "relief", "calm", "peaceful", "relaxed"],
  "😍": ["happy", "love", "heart", "adore", "crush"],
  "🥰": ["happy", "love", "heart", "adore", "affection"],
  "😘": ["happy", "love", "kiss", "blow", "romantic"],
  "😗": ["happy", "kiss", "love", "romantic"],
  "😙": ["happy", "kiss", "love", "smile"],
  "😚": ["happy", "kiss", "love", "blush"],
  "😋": ["happy", "yummy", "tasty", "delicious", "food"],
  "😛": ["happy", "tongue", "playful", "silly", "cheeky"],
  "😝": ["happy", "tongue", "silly", "funny", "playful"],
  "😜": ["happy", "tongue", "wink", "silly", "playful"],
  "🤪": ["happy", "crazy", "wild", "silly", "zany"],
  "🤨": ["confused", "skeptical", "doubt", "suspicious", "unsure"],
  "🧐": ["confused", "monocle", "thinking", "analyzing", "curious"],
  "🤓": ["happy", "nerd", "glasses", "smart", "studious"],
  "😎": ["happy", "cool", "sunglasses", "confident", "awesome"],
  "🤩": ["happy", "star", "amazed", "wow", "excited"],
  "🥳": ["happy", "party", "celebration", "fun", "excited"],
  "😏": ["happy", "smirk", "sly", "confident", "playful"],
  "😒": ["sad", "unamused", "disappointed", "annoyed", "bored"],
  "😞": ["sad", "disappointed", "down", "unhappy", "dejected"],
  "😔": ["sad", "pensive", "thoughtful", "down", "melancholy"],
  "😟": ["sad", "worried", "concerned", "anxious", "nervous"],
  "😕": ["sad", "confused", "unsure", "uncertain", "doubtful"],
  "🙁": ["sad", "frown", "unhappy", "down", "depressed"],
  "☹️": ["sad", "frown", "unhappy", "down", "depressed"],
  "😣": ["sad", "persevere", "struggle", "frustrated", "stressed"],
  "😖": ["sad", "confounded", "confused", "frustrated", "stressed"],
  "😫": ["sad", "tired", "exhausted", "weary", "drained"],
  "😩": ["sad", "weary", "tired", "exhausted", "drained"],
  "🥺": ["sad", "pleading", "puppy", "begging", "cute"],
  "😢": ["sad", "tear", "cry", "tearful", "crying"],
  "😭": ["sad", "sob", "cry", "tears", "loudly"],
  "😤": ["angry", "huff", "steam", "annoyed", "frustrated"],
  "😠": ["angry", "angry", "mad", "furious", "upset"],
  "😡": ["angry", "pouting", "mad", "furious", "rage"],
  "🤬": ["angry", "cursing", "rage", "furious", "profanity"],
  "🤯": ["shocked", "exploding", "mind", "wow", "amazed"],
  "😳": ["shocked", "flushed", "surprised", "embarrassed", "blush"],
  "🥵": ["hot", "hot", "sweat", "temperature", "warm"],
  "🥶": ["cold", "cold", "freeze", "temperature", "chilly"],
  "😱": ["scared", "fear", "scream", "terrified", "shocked"],
  "😨": ["scared", "anxious", "fear", "worried", "nervous"],
  "😰": ["scared", "cold", "sweat", "fear", "anxious"],
  "😥": ["sad", "sad", "but", "relieved", "mixed"],
  "😓": ["sad", "sweat", "relief", "anxious", "nervous"],
  "🤗": ["happy", "hug", "love", "caring", "affection"],
  "🤔": ["thinking", "thinking", "consider", "ponder", "wonder"],
  "🤭": ["happy", "giggle", "laugh", "secret", "funny"],
  "🤫": ["quiet", "shh", "secret", "silent", "hush"],
  "🤥": ["lying", "pinocchio", "lie", "dishonest", "false"],
  "😶": ["neutral", "no", "mouth", "silent", "speechless"],
  "😐": ["neutral", "expressionless", "blank", "poker", "face"],
  "😑": ["neutral", "expressionless", "unamused", "flat", "serious"],
  "😬": ["grimace", "grimace", "awkward", "nervous", "cringe"],
  "🙄": ["annoyed", "roll", "eyes", "whatever", "bored"],
  "😯": ["surprised", "hushed", "shock", "silence", "wow"],
  "😦": ["frowning", "frown", "concerned", "worried", "confused"],
  "😧": ["anguished", "anguish", "pain", "distress", "suffering"],
  "😮": ["surprised", "open", "mouth", "wow", "shock"],
  "😲": ["astonished", "astonished", "shock", "amazed", "wow"],
  "🥱": ["tired", "yawning", "sleepy", "bored", "exhausted"],
  "😴": ["sleeping", "sleep", "tired", "bed", "rest"],
  "🤤": ["drooling", "drool", "sleep", "hungry", "desire"],
  "😪": ["sleepy", "sleep", "tired", "exhausted", "drowsy"],
  "😵": ["dizzy", "spiral", "confused", "disoriented", "woozy"],
  "🤐": ["zipped", "mouth", "quiet", "silent", "secret"],
  "🥴": ["woozy", "drunk", "dizzy", "confused", "spiral"],
  "🤢": ["sick", "nausea", "green", "ill", "vomit"],
  "🤮": ["vomiting", "vomit", "sick", "nausea", "ill"],
  "🤧": ["sneezing", "sneeze", "sick", "cold", "allergy"],
  "😷": ["sick", "mask", "health", "doctor", "illness"],
  "🤒": ["sick", "thermometer", "ill", "fever", "temperature"],
  "🤕": ["injured", "bandage", "hurt", "pain", "injury"],
  "🤑": ["money", "dollar", "rich", "wealth", "cash"],
  "🤠": ["cowboy", "hat", "western", "yeehaw", "country"],
  "😈": ["devil", "smile", "evil", "naughty", "bad"],
  "👿": ["devil", "angry", "evil", "naughty", "bad"],
  "👹": ["ogre", "monster", "scary", "creepy", "goblin"],
  "👺": ["goblin", "monster", "scary", "creepy", "troll"],
  "🤡": ["clown", "funny", "scary", "creepy", "circus"],
  "💩": ["poop", "shit", "crap", "toilet", "gross"],
  "👻": ["ghost", "spooky", "scary", "halloween", "spirit"],
  "💀": ["skull", "death", "dead", "skeleton", "scary"],
  "☠️": ["skull", "crossbones", "death", "pirate", "danger"],
  "👽": ["alien", "ufo", "space", "extraterrestrial", "sci-fi"],
  "👾": ["monster", "alien", "space", "invader", "game"],
  "🤖": ["robot", "technology", "ai", "machine", "cyborg"],
  "🎃": ["pumpkin", "halloween", "jack", "lantern", "autumn"],
  "😺": ["cat", "happy", "smile", "feline", "pet"],
  "😸": ["cat", "grin", "happy", "feline", "pet"],
  "😹": ["cat", "joy", "laugh", "happy", "feline"],
  "😻": ["cat", "heart", "love", "eyes", "feline"],
  "😼": ["cat", "smirk", "sly", "feline", "pet"],
  "😽": ["cat", "kiss", "love", "feline", "pet"],
  "🙀": ["cat", "weary", "shock", "surprised", "feline"],
  "😿": ["cat", "crying", "sad", "tear", "feline"],
  "😾": ["cat", "pouting", "angry", "feline", "pet"],
  "👋": ["wave", "hello", "goodbye", "greeting", "bye"],
  "🤚": ["raised", "back", "hand", "stop", "halt"],
  "🖐️": ["hand", "fingers", "stop", "five", "palm"],
  "✋": ["raised", "hand", "stop", "halt", "wait"],
  "🖖": ["vulcan", "salute", "spock", "live", "prosper"],
  "👌": ["ok", "hand", "okay", "good", "perfect"],
  "🤏": ["pinching", "hand", "small", "little", "tiny"],
  "✌️": ["victory", "peace", "hand", "two", "fingers"],
  "🤞": ["crossed", "fingers", "luck", "hope", "wish"],
  "🤟": ["love-you", "gesture", "hand", "sign", "love"],
  "🤘": ["sign", "horns", "rock", "metal", "music"],
  "🤙": ["call", "hand", "phone", "shaka", "hang"],
  "👈": ["backhand", "left", "point", "index", "direction"],
  "👉": ["backhand", "right", "point", "index", "direction"],
  "👆": ["backhand", "up", "point", "index", "direction"],
  "🖕": ["middle", "finger", "up", "rude", "offensive"],
  "👇": ["backhand", "down", "point", "index", "direction"],
  "☝️": ["backhand", "up", "point", "index", "direction"],
  "👍": ["thumbs", "up", "like", "good", "approve"],
  "👎": ["thumbs", "down", "dislike", "bad", "disapprove"],
  "✊": ["raised", "fist", "power", "strength", "solidarity"],
  "👊": ["oncoming", "fist", "punch", "fight", "hit"],
  "🤛": ["left", "fist", "bump", "greeting", "bro"],
  "🤜": ["right", "fist", "bump", "greeting", "bro"],
  "👏": ["clapping", "hands", "applause", "praise", "congrats"],
  "🙌": ["raising", "hands", "celebration", "praise", "hooray"],
  "👐": ["open", "hands", "hug", "embrace", "welcome"],
  "🤲": ["palms", "up", "hands", "open", "give"],
  "🤝": ["handshake", "agreement", "deal", "partnership", "greeting"],
  "🙏": ["folded", "hands", "pray", "thanks", "please"],
  "✍️": ["writing", "hand", "write", "pen", "note"],
  "💅": ["nail", "polish", "beauty", "fashion", "grooming"],
  "🤳": ["selfie", "camera", "phone", "photo", "picture"],
  "💪": ["flexed", "biceps", "strong", "muscle", "power"],
  "🦾": ["mechanical", "leg", "prosthetic", "robot", "disability"],
  "🦿": ["mechanical", "leg", "prosthetic", "robot", "disability"],
  "🦵": ["leg", "foot", "limb", "walk", "kick"],
  "🦶": ["foot", "toes", "limb", "walk", "step"],
  "👂": ["ear", "listen", "hearing", "sound", "audio"],
  "🦻": ["ear", "hearing", "aid", "deaf", "listen"],
  "👃": ["nose", "smell", "scent", "breath", "booger"],
  "🧠": ["brain", "mind", "think", "smart", "intelligence"],
  "🫀": ["heart", "anatomy", "organ", "love", "life"],
  "🫁": ["lungs", "anatomy", "organ", "breath", "health"],
  "🦷": ["tooth", "dental", "smile", "dentist", "bite"],
  "🦴": ["bone", "skeleton", "dog", "anatomy", "fossil"],
  "👀": ["eyes", "see", "look", "watch", "vision"],
  "👁️": ["eye", "see", "look", "watch", "vision"],
  "👅": ["tongue", "taste", "lick", "mouth", "speak"],
  "👄": ["lips", "mouth", "kiss", "speak", "talk"],
  "💋": ["kiss", "mark", "love", "romance", "red"],
  "🩸": ["blood", "drop", "red", "donate", "injury"],
  "🔥": ["fire", "hot", "burn", "flame", "heat"],
  "💥": ["collision", "boom", "explosion", "impact", "crash"],
  "💫": ["dizzy", "star", "spin", "magic", "twinkle"],
  "💦": ["sweat", "droplets", "water", "wet", "splash"],
  "💨": ["dash", "wind", "air", "fast", "speed"],
  "🌟": ["glowing", "star", "bright", "shine", "star"],
  "⭐": ["star", "favorite", "rating", "bright", "shine"],
  "✨": ["sparkles", "magic", "shine", "glitter", "sparkle"],
  "⚡": ["high", "voltage", "lightning", "electric", "power"],
  "☄️": ["comet", "space", "star", "tail", "meteor"],
  "💯": ["hundred", "points", "score", "perfect", "100"],
  "🎉": ["party", "popper", "celebration", "fun", "confetti"],
  "🎊": ["confetti", "ball", "celebration", "party", "fun"],
  "🎈": ["balloon", "party", "celebration", "birthday", "fun"],
  "🎂": ["birthday", "cake", "celebration", "party", "candle"],
  "🎀": ["ribbon", "bow", "gift", "decoration", "pink"],
  "🎁": ["gift", "present", "box", "surprise", "wrap"],
  "🏆": ["trophy", "winner", "award", "prize", "victory"],
  "🥇": ["first", "medal", "gold", "winner", "place"],
  "🥈": ["second", "medal", "silver", "place", "runner-up"],
  "🥉": ["third", "medal", "bronze", "place", "podium"],
  "⚽": ["soccer", "ball", "football", "sport", "game"],
  "⚾": ["baseball", "ball", "sport", "game", "pitch"],
  "🥎": ["softball", "ball", "sport", "game", "pitch"],
  "🏀": ["basketball", "ball", "sport", "game", "hoop"],
  "🏐": ["volleyball", "ball", "sport", "game", "net"],
  "🏈": ["football", "ball", "sport", "game", "touchdown"],
  "🏉": ["rugby", "ball", "sport", "game", "try"],
  "🎾": ["tennis", "ball", "sport", "game", "racket"],
  "❤️": ["heart", "love", "red", "romance", "affection"],
  "🧡": ["heart", "love", "orange", "romance", "affection"],
  "💛": ["heart", "love", "yellow", "romance", "affection"],
  "💚": ["heart", "love", "green", "romance", "affection"],
  "💙": ["heart", "love", "blue", "romance", "affection"],
  "💜": ["heart", "love", "purple", "romance", "affection"],
  "🤎": ["heart", "love", "brown", "romance", "affection"],
  "🖤": ["heart", "love", "black", "romance", "affection"],
  "🤍": ["heart", "love", "white", "romance", "affection"],
  "💔": ["heart", "break", "broken", "sad", "love"],
  "❣️": ["heart", "exclamation", "love", "red", "affection"],
  "💕": ["two", "hearts", "love", "romance", "couple"],
  "💞": ["revolving", "hearts", "love", "romance", "affection"],
  "💓": ["beating", "heart", "love", "pulse", "romance"],
  "💗": ["growing", "heart", "love", "romance", "affection"],
  "💖": ["sparkling", "heart", "love", "romance", "affection"],
  "💘": ["cupid", "heart", "love", "arrow", "romance"],
  "💝": ["heart", "ribbon", "love", "gift", "romance"],
  "🌹": ["rose", "flower", "love", "romance", "red"],
  "🌺": ["hibiscus", "flower", "bloom", "tropical", "pink"],
  "🌻": ["sunflower", "flower", "yellow", "sun", "bloom"],
  "🌷": ["tulip", "flower", "spring", "bloom", "garden"],
  "🌸": ["cherry", "blossom", "flower", "pink", "spring"]
};

// Helper function to search emojis by keyword
export const searchEmojisByKeyword = (keyword) => {
  if (!keyword) return [];
  const lowerKeyword = keyword.toLowerCase();
  const results = [];
  
  for (const [emoji, keywords] of Object.entries(EMOJI_KEYWORDS)) {
    if (keywords.some(k => k.includes(lowerKeyword))) {
      results.push(emoji);
    }
  }
  
  return results;
};
